<template>
    <fieldset aria-describedby="content-info-text">
        <legend
            :id="uniqueId"
            class="legendelement"
        >
            {{ label }}
        </legend>
        <div class="search-container">
            <div class="search-field-container">
                <div class="input-group search-group">
                    <input
                        v-model="model"
                        type="text"
                        class="search"
                        :aria-label="inputAriaLabel"
                        maxlength="4"
                        @keydown.enter.prevent="search"
                        @input="validateInput"
                        @keydown.enter="search"
                    >
                    <button
                        v-if="model.length > 0"
                        class="closebutton"
                        :aria-label="crossIconAlt"
                        @click="emptyResults"
                    >
                        <img
                            class="close-icon"
                            :src="crossIcon"
                            :alt="crossIconAlt"
                            aria-hidden="true"
                        >
                    </button>
                    <input
                        class="searchbutton"
                        type="button"
                        role="button"
                        :aria-label="searchLabel"
                        @click="search"
                    >
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Watch } from "vue-facing-decorator"
    import RadiomikrofonitaajuudetService from "@/services/RadiomikrofonitaajuudetService"
    import { store } from '@/store/store'

    @Component
    export default class TextField extends Vue {
        @Prop({ type: String }) readonly label: string | undefined
        model: string = ""
        uniqueId: string = ""
        pageName: string = "Radiomikrofonitaajuudet"
        radiomikrofonitaajuudetService: RadiomikrofonitaajuudetService = new RadiomikrofonitaajuudetService()

        created() {
            this.uniqueId = "id-" + Math.random().toString(16).slice(2)
            this.model = this.bandwidth
        }

        deactivated() {
            this.emptyResults()
        }

        get bandwidth(): string {
            return store.getters.radiomikrofonitBandwidth.toString()
        }

        get rightSlotData(): string {
            return store.getters.rightSlotData
        }

        @Watch("rightSlotData")
        onRightSlotDataChanged(newVal: string) {
            if (store.getters.rightSlot === "Radiomikrofonitaajuudet" && newVal !== "") {
                // Päivitetään modeliin kaistanleveys, jota RadiomikrofonitService käytti haussa.
                // Tätä tarvitaan jos käyttäjä on tyhjentänyt kaistanleveyskentän.
                this.model = this.bandwidth
            }
        }

        get crossIcon(): string {
            return store.getters.contentServiceUrl + "/Content/icons/svg-blue/ruksi.svg" + "?" + store.getters.contentServiceTimeStamp
        }

        get crossIconAlt(): string | undefined {
            return this.$t("App.SearchAddress.ClearSearchfield")
        }

        emptyResults(): void {
            this.model = ""
            store.dispatch("setFrequencySearchData", {
                lat: store.getters.frequencySearchData.lat,
                lng: store.getters.frequencySearchData.lng,
                f1: store.getters.frequencySearchData.f1,
                f2: store.getters.frequencySearchData.f2,
                bw: ""
            })
            this.search()
        }

        get searchLabel(): string | undefined {
            return this.$t("App.SearchButton.Label")
        }

        async search(): Promise<void> {
            // haku annettujen tietojen perusteella
            store.dispatch("setLoading", { name: this.pageName, value: true })
            store.dispatch("setFrequencySearchData", {
                lat: store.getters.frequencySearchData.lat,
                lng: store.getters.frequencySearchData.lng,
                f1: store.getters.frequencySearchData.f1,
                f2: store.getters.frequencySearchData.f2,
                bw: store.getters.frequencySearchData.bw
            })
            this.radiomikrofonitaajuudetService.availableFrequenciesSearch()

            store.dispatch("setLoading", { name: this.pageName, value: false })
        }

        get inputAriaLabel() {
            return this.label
        }

        validateInput() {
            // Allow only numbers
            this.model = this.model.replace(/\D/g, "")
            store.dispatch("setFrequencySearchData", {
                lat: store.getters.frequencySearchData.lat,
                lng: store.getters.frequencySearchData.lng,
                f1: store.getters.frequencySearchData.f1,
                f2: store.getters.frequencySearchData.f2,
                bw: this.model
            })
        }
    }
</script>

<style scoped>
    .legendelement {
        font-size: 1.125rem;
    }

    .search-group input.search {
        width: unset;
        flex-grow: 1;
        height: 3.125rem;
        overflow: hidden;
        padding-right: 2.1rem;
        resize: none;
    }

    .closebutton {
        background: none;
        border: none;
        margin: 0;
        padding: 0;
        cursor: pointer;
        font-weight: 600;
        position: absolute;
        right: 70px;
        top: 12px;
    }
</style>
